<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XBHRJE/tc-custom/9781429974936.jpg?1731166583793" alt="This image is the cover for the book House of Reeds, In The Time of The Sixth Sun"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">House of Reeds, In The Time of The Sixth Sun
      </h1>
      <p class="bookDescription body article font2">
        <p>In five short centuries, the mighty Empire of the Méxica, descendants of the ancient Aztecs allied with Imperial Japan, has spread out to conquer the Earth, left the homeworld, and set its sights on the stars. But the universe is a dangerous place, filled with hidden powers and the relics of ancient civilizations. The Méxica are only the latest of the great Imperial powers to reach for the stars. <br/><br/>But that doesn't stop Imperial Méxica from claiming control. <br/><br/>Xenoarcheologist Gretchen Anderssen had hoped to enjoy her well-earned vacation. She hadn't seen her home-world or her children for many months. But the Company has other plans for her - when she checks in for her transport, she finds new orders for her team. It looks like only a small diversion - a quick trip to the Planet Jagen, to investigate reports of a possible First Sun artifact. She doesn't have to run an excavation, or even gain possession of the artifact. Just file a report. But it smells bad, says Gretchen's Hesht companion, Magdalena. David Parker, the Company pilot assigned to Anderssen's analysis team agrees. And they are so right.<br/><br/>Gretchen, Magdalena, and Parker find themselves in very dangerous territory indeed. Because, unbeknownst to anyone at the Company, the Imperial Méxican Priesthood has decided to wage a war on Jagan - a war not of conquest or defense, but a "flowery war", planned and fomented for the purpose of blooding the Emperor's youngest son. Gretchen and her team are headed right into the middle of the battle.<br/><br/>It may be a War of Flowers, but many people will die, and blood will flow in the streets. <br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas Harlan
      </h2>
      
      <p class="authorDescription body article"><P><B>Thomas Harlan</B> is the author of the highly regarded "Oath of Empire" fantasy series, as well as being an internationally-known game designer.  He lives in Salem, Oregon.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7488bab2